import React from "react";
import sourceCode from "../../assets/source-code.png";
import phone from "../../assets/phone.png";
import desktop from "../../assets/desktop.png";

const Services = () => {
  return (
    <>
      <div className="services-card-container">
        <div className="services-card">
          <div>
            <p className="card-heading">Development</p>
            <p>
              We prioritize clean code practices, seamless API integration, and
              third-party integration to deliver robust and scalable
              applications. We specialize in scalable architecture, RESTful API
              development, data streaming, and microservices architecture.
              Whether you need a powerful API backend or real-time messaging
              system, we deliver high-performance solutions tailored to your
              business needs.
            </p>
          </div>
          <img src={sourceCode} width="50px" height="50px" />
        </div>
        <div className="services-card">
          <div>
            <p className="card-heading">Responsive Design</p>
            <p>
              Crafting websites and apps that seamlessly adapt to all screens
              ensures accessibility and usability. Whether building or
              revamping, our solutions promise optimal performance and
              engagement on desktops, tablets, and mobiles.
            </p>
          </div>
          <img src={phone} width="50px" height="50px" />
        </div>
        <div className="services-card">
          <div>
            <p className="card-heading">Product Design</p>
            <p>
              We create user-centered digital products using agile
              methodologies. Our collaborative approach seamlessly integrates
              design and development, resulting in intuitive, functional
              solutions. Whether it's a web app, mobile app, or e-commerce
              platform, we deliver tailored solutions from ideation to launch.
            </p>
          </div>
          <img src={desktop} width="50px" height="50px" />
        </div>
      </div>
    </>
  );
};

export default Services;
